import ExpertForm from "./Form";
import UnapprovedPanel from "./UnapprovedPanel";

export default function ExpertPanel({ practitionerProfile }) {
  return practitionerProfile.isApprovedToBeExpert ? (
    <ExpertForm practitionerProfile={practitionerProfile} />
  ) : (
    <UnapprovedPanel />
  );
}
